export const API_EXTERNAL_ENDPOINT =
  'cottage-reviews/destination/:destination_slug'

export const API_INTERNAL_ENDPOINT =
  'rurality/v3/cottage-reviews/destination/detail'
